<template>
  <v-dialog
    v-model="dialogVisible"
    max-width="500"
    @click:outside="handleClose"
  >
    <v-card color="#2B2D33">
      <v-card-title class="d-flex justify-space-between align-center pa-4 text-white" style="border-bottom: 1px solid #48494D;">
        <span>上传图片</span>
        <v-btn
          icon="mdi-close"
          variant="text"
          @click="handleClose"
        />
      </v-card-title>

      <v-card-text class="pa-4">
        <!-- 上传区域 
          @click="$refs.fileInput.click()"-->
        <div 
          class="upload-area"
          @dragover.prevent
          @drop.prevent="handleDrop"
          tabindex="0"
          ref="uploadArea"
        >
          <input
            ref="fileInput"
            type="file"
            :accept="mode === 'replace' ? (type === 'dwg' ? '.dwg' : '.jpg,.jpeg,.png,.webp,.pdf') : ('.jpg,.jpeg,.png,.webp,.pdf')"
            multiple="false"
            class="hidden-input"
            @change="handleFileChange"
          >
          
          <img src="@/assets/uploadLogo.png" alt="上传" style="width: 90px;">
          <div style="font-size: 20px;font-weight: bold;">方式一</div>
          <div style="font-size: 18px;font-weight: normal;text-align: center;margin-top: 10px;">
            第一步:<span style="color: #ff5252;">截图</span> 要上传的内容 <br>  
            第二步:按<kbd style="margin-left: 5px;font-size: 18px;">Ctrl+V</kbd>
          </div>
        </div>
      </v-card-text>
      <!-- 方式二 -->
      <v-card-text class="pa-4" style="padding: 0px 16px 32px 16px!important;">
        <!-- 上传区域
          @drop.prevent="handleDrop"
          @dragover.prevent -->
        <div 
          class="upload-area2"
          @click="$refs.fileInput2.click()"
          tabindex="0"
          ref="uploadArea"
        >
          <input
            ref="fileInput2"
            type="file"
            :accept="mode === 'replace' ? (type === 'dwg' ? '.dwg' : '.jpg,.jpeg,.png,.webp,.pdf') : ('.jpg,.jpeg,.png,.webp,.pdf')"
            multiple="false"
            class="hidden-input"
            @change="handleFileChange"
          >
          
          <div class="d-flex align-center justify-space-between">
            <div style="font-size: 20px;font-weight: bold;">方式二</div>
            <v-btn variant="text" style="padding: 4px 6px;background: #2C2D32;">上传本地文件</v-btn>
          </div>
        </div>
      </v-card-text>

      <v-card-text style="padding: 0px 16px 16px 16px!important;">
        <!-- 文件列表 -->
        <v-list v-if="files?.length" class="file-list mt-4" color="#2B2D33">
          <v-list-item
            v-for="(file, index) in files"
            :key="index"
            class="file-item"
            color="#3A3B3F"
          >
            <template v-slot:prepend>
              <v-icon
                :color="isValidFileType(file) ? 'primary' : 'error'"
                :icon="isValidFileType(file) ? 'mdi-file-image' : 'mdi-file-alert'"
              />
            </template>

            <v-list-item-title>
              {{ file.name }}
            </v-list-item-title>

            <v-list-item-subtitle>
              {{ formatFileSize(file.size) }}
              <span v-if="!isValidFileType(file)" class="text-error">
                - 不支持的文件格式
              </span>
            </v-list-item-subtitle>

            <template v-slot:append>
              <v-btn
                icon="mdi-close"
                variant="text"
                size="small"
                @click="removeFile(index)"
              />
            </template>
          </v-list-item>
        </v-list>

        <!-- 上传进度 -->
        <div v-if="uploading" class="progress-container mt-4">
          <div class="d-flex align-start">
            <v-icon
              icon="mdi-cloud-upload"
              color="primary"
              class="mr-2"
            />
            <div class="progress-info">
              正在上传 {{ uploadedCount }}/{{ totalCount }} ({{ Math.round(uploadProgress) }}%))
            </div>
          </div>
        </div>

        <div v-if="converting && currentPdfName" class="progress-container mt-4">
          <div class="d-flex align-start">
            <v-icon
              icon="mdi-file-pdf"
              color="primary"
              class="mr-2"
            />
            <div class="progress-info">
              正在转换PDF "{{ currentPdfName }}" 第 {{ convertedPages }}/{{ totalPages }} 页
            </div>
          </div>
        </div>

        <!-- 等待转换提示 -->
        <div 
          v-if="waitingPdfNames.length > 0" 
          class="progress-container mt-4"
        >
          <div class="d-flex align-start">
            <v-icon
              icon="mdi-file-clock"
              color="warning"
              class="mr-2"
            />
            <div class="progress-info waiting-files">
              等待转换：{{ waitingPdfNames.join('、') }}
            </div>
          </div>
        </div>
        <!-- 错误提示 -->
        <v-alert
          v-if="error"
          type="error"
          variant="tonal"
          class="mt-4"
          closable
          @click:close="error = null"
        >
          {{ error }}
        </v-alert>
      </v-card-text>
      <v-divider color="rgba(255, 255, 255, 0.12)" />

      <!-- 底部操作栏 -->
      <!-- <v-card-actions class="pa-4">
        <v-spacer />
        <v-btn
          color="error"
          variant="tonal"
          :disabled="uploading"
          @click="handleClose"
          style="margin-right: 16px;"
        >
          取消
        </v-btn>
        <v-btn
          color="primary"
          variant="flat"
          :loading="uploading"
          :disabled="!canUpload"
          class="ml-2"
          @click="handleUpload"
        >
          <template v-if="uploading">
            {{ uploadedCount }}/{{ totalCount }} ({{ Math.round(uploadProgress) }}%))
          </template>
          <template v-else>
            {{ mode === 'new' ? '开始上传' : '替换' }}
          </template>
        </v-btn>
      </v-card-actions> -->
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted, watch } from 'vue'
import * as pdfjsLib from 'pdfjs-dist'
import { getPdfWorkerUrl } from '@/utils/pdfWorker'

// 设置 PDF.js worker
pdfjsLib.GlobalWorkerOptions.workerSrc = getPdfWorkerUrl()

import { uploadApi } from '@/services/api'

const props = defineProps<{
  modelValue: boolean
  mode: 'new' | string
  type: 'image' | 'dwg'
  uploading?: boolean
  uploadProgress?: number
  error?: string | null
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'upload', urls: string[]): void
  (e: 'update:files', files: File[] | null): void
}>()

const fileInput = ref<HTMLInputElement | null>(null)
const fileInput2 = ref<HTMLInputElement | null>(null)
const uploadArea = ref<HTMLDivElement | null>(null)
const files = ref<File[] | null>(null)
const uploading = ref(false)
const uploadProgress = ref(0)
const error = ref<string | null>(null)
const converting = ref(false)
const convertProgress = ref(0)
const totalPages = ref(0)
const convertedPages = ref(0)
const currentPdfName = ref('')
const processingQueue = ref<File[]>([])  
const isProcessing = ref(false)  
const uploadedCount = ref(0)  // 添加已上传数量计数器
const totalCount = ref(0)     // 添加总文件数计数器

const dialogVisible = computed({
  get() {
    return props.modelValue
  },
  set(value) {
    emit('update:modelValue', value)
  }
})

// 获取等待转换的PDF文件名列表
const waitingPdfNames = computed(() => {
  // 从第二个文件开始，因为第一个正在转换
  return processingQueue.value
    .slice(1)  // 跳过第一个正在处理的文件
    .filter(file => file.type === 'application/pdf')
    .map(file => file.name)
})

// 是否可以上传
const canUpload = computed(() => {
  // 如果没有文件，不能上传
  if (!files.value?.length) return false
  // 如果是替换模式且有多个文件，不能上传
  if (props.mode === 'replace' && files.value.length > 1) return false
  // 如果有文件正在转换中，不能上传
  if (converting.value || processingQueue.value.length > 0) return false
  // 所有文件必须是有效的文件类型
  return files.value.every(file => isValidFileType(file))
})

// 监听 canUpload 变化，当为 true 时自动执行上传
watch(canUpload, (newValue) => {
  if (newValue && !uploading.value) {
    handleUpload()
  }
})

// 验证文件类型
const isValidFileType = (file: File) => { 
  const validTypes = ['','image/jpeg', 'image/png', 'image/webp', 'application/pdf', 'image/dwg']
  return validTypes.includes(file.type)
}

// 格式化文件大小
const formatFileSize = (size: number) => {
  if (size < 1024) return size + ' B'
  if (size < 1024 * 1024) return (size / 1024).toFixed(2) + ' KB'
  return (size / (1024 * 1024)).toFixed(2) + ' MB'
}

// PDF转图片函数
const convertPdfToImages = async (file: File): Promise<File[]> => {
  const imageFiles: File[] = []
  converting.value = true
  convertedPages.value = 0
  totalPages.value = 0
  currentPdfName.value = file.name
  
  try {
    const arrayBuffer = await file.arrayBuffer()
    const loadingTask = pdfjsLib.getDocument(arrayBuffer)
    const pdf = await loadingTask.promise
    totalPages.value = pdf.numPages
    
    for (let pageNum = 1; pageNum <= totalPages.value; pageNum++) {
      const page = await pdf.getPage(pageNum)
      const viewport = page.getViewport({ scale: 1.5 })
      
      const canvas = document.createElement('canvas')
      const context = canvas.getContext('2d')
      canvas.height = viewport.height
      canvas.width = viewport.width
      
      await page.render({
        canvasContext: context,
        viewport: viewport
      }).promise
      
      const blob = await new Promise<Blob>(resolve => {
        canvas.toBlob(blob => resolve(blob), 'image/jpeg', 0.95)
      })
      
      const imageFile = new File([blob], `${file.name.replace('.pdf', '')}_${pageNum}.jpg`, {
        type: 'image/jpeg'
      })
      
      imageFiles.push(imageFile)
      convertedPages.value = pageNum
    }
    
    return imageFiles
  } catch (error) {
    console.error('PDF转换错误:', error)
    throw new Error('PDF文件转换失败')
  } finally {
    converting.value = false
    currentPdfName.value = ''
  }
}

// 处理队列中的文件
const processQueuedFiles = async () => {
  if (processingQueue.value.length === 0 || converting.value) {
    return
  }

  converting.value = true
  const pdfFile = processingQueue.value[0]
  currentPdfName.value = pdfFile.name

  try {
    // 转换PDF为图片
    const images = await convertPdfToImages(pdfFile)
    
    // 将转换后的图片添加到文件列表
    files.value = files.value.filter(f => f !== pdfFile) // 移除原始PDF
    files.value = [...files.value, ...images]
    
    // 从队列中移除已处理的PDF
    processingQueue.value.shift()
    
    // 重置转换状态
    converting.value = false
    currentPdfName.value = ''
    convertedPages.value = 0
    totalPages.value = 0

    // 继续处理队列中的下一个文件
    if (processingQueue.value.length > 0) {
      processQueuedFiles()
    }
  } catch (err) {
    console.error('PDF转换失败:', err)
    error.value = `PDF "${pdfFile.name}" 转换失败: ${err.message}`
    
    // 从队列和文件列表中移除失败的PDF
    processingQueue.value.shift()
    files.value = files.value.filter(f => f !== pdfFile)
    
    // 重置转换状态
    converting.value = false
    currentPdfName.value = ''
    convertedPages.value = 0
    totalPages.value = 0

    // 继续处理队列中的下一个文件
    if (processingQueue.value.length > 0) {
      processQueuedFiles()
    }
  }
}

// 添加文件到处理队列
const addToProcessingQueue = (newFiles: File[]) => {
  if (props.mode === 'replace') {
    // 替换模式下只保留最后选择的文件
    files.value = [newFiles[newFiles.length - 1]]
    processingQueue.value = []
  } else {
    // 新增模式下追加所有文件
    files.value = [...(files.value || []), ...newFiles]
  }

  // 将PDF文件添加到处理队列
  const pdfFiles = files.value.filter(file => file.type === 'application/pdf')
  processingQueue.value.push(...pdfFiles)
  
  // 如果有PDF文件且当前没有正在转换的文件，开始处理队列
  if (pdfFiles.length > 0 && !converting.value) {
    processQueuedFiles()
  }
}

// 处理文件改变
const handleFileChange = async (event: Event) => {
  const input = event.target as HTMLInputElement
  if (!input.files?.length) return
  
  try {
    const files = Array.from(input.files)
    if (files.length > 1) {
      error.value = '一次只能选择一张图片，请重新选择'
      input.value = '' // 清空输入框
      return
    }
    // 将文件添加到处理队列
    addToProcessingQueue(Array.from(input.files))
  } finally {
    input.value = ''
  }
}

// 处理拖放
const handleDrop = async (event: DragEvent) => {
  if (!event.dataTransfer?.files.length) return
  
  // 将文件添加到处理队列
  addToProcessingQueue(Array.from(event.dataTransfer.files))
}


// 全局粘贴事件处理（支持复制和剪切）
const handleGlobalPaste = (event: ClipboardEvent) => {
  // 只有当对话框打开时才处理粘贴事件
  if (!dialogVisible.value) return
  
  const clipboardData = event.clipboardData
  if (!clipboardData) return

  const items = clipboardData.items
  if (!items) return

  for (let i = 0; i < items.length; i++) {
    const item = items[i]
    if (item.type.indexOf('image') !== -1) {
      const blob = item.getAsFile()
      if (blob) {
        try {
          // 处理粘贴的图片（支持复制和剪切）
          const imageFile = processPastedImage(blob)
          // 将处理后的图片添加到处理队列
          addToProcessingQueue([imageFile])
          // 显示粘贴成功提示
          showPasteSuccess()
        } catch (err) {
          console.error('处理粘贴图片失败:', err)
          error.value = '粘贴图片处理失败，请重试'
        }
        // 阻止默认粘贴行为
        event.preventDefault()
        return
      }
    }
  }
}

// 显示粘贴成功提示
const showPasteSuccess = () => {
  // 清除之前的错误信息
  error.value = null
  // 可以在这里添加其他成功提示逻辑
}

// 处理粘贴的图片数据（支持复制和剪切）
const processPastedImage = (blob: Blob): File => {
  // 为粘贴的图片生成文件名
  const timestamp = new Date().getTime()
  const extension = getImageExtension(blob.type)
  const fileName = `pasted_image_${timestamp}.${extension}`
  
  // 将Blob转换为File对象
  return new File([blob], fileName, { type: blob.type })
}

// 获取图片文件扩展名
const getImageExtension = (mimeType: string): string => {
  const extensions: Record<string, string> = {
    'image/jpeg': 'jpg',
    'image/jpg': 'jpg',
    'image/png': 'png',
    'image/webp': 'webp',
    'image/gif': 'gif',
    'image/bmp': 'bmp'
  }
  
  return extensions[mimeType] || 'png'
}

// 组件挂载时添加全局粘贴事件监听器
onMounted(() => {
  document.addEventListener('paste', handleGlobalPaste)
})

// 组件卸载时移除全局粘贴事件监听器
onUnmounted(() => {
  document.removeEventListener('paste', handleGlobalPaste)
})

// 移除文件
const removeFile = (index: number) => {
  if (!files.value) return
  
  // 过滤掉要删除的文件
  files.value = files.value.filter((_, i) => i !== index)
  
  // 如果没有文件了，清空文件列表
  if (files.value.length === 0) {
    files.value = null
  }
  
  // 更新父组件的文件列表
  emit('update:files', files.value)
  
  // 清除错误提示
  error.value = ''
}

// 处理关闭
const handleClose = () => {
  if (uploading.value) return
  dialogVisible.value = false
  files.value = null
  emit('update:files', null)
}

// 处理上传
const handleUpload = async () => {
  if (!files.value || files.value.length === 0) {
    error.value = '请选择要上传的文件'
    return
  }
  
  if (!files.value.every(file => isValidFileType(file))) {
    error.value = '存在不支持的文件格式'
    return
  }
  
  uploading.value = true
  error.value = ''
  uploadProgress.value = 0
  uploadedCount.value = 0
  totalCount.value = files.value.length
  
  try {
    console.log('开始上传文件:', files.value)
    // 使用新的批量上传接口
    const uploadedUrls = await uploadApi.uploadFiles(
      files.value,
      (progress) => {
        uploadProgress.value = progress
        console.log('总体上传进度:', progress)
      },
      (fileIndex, progress) => {
        // 当一个文件完成上传时更新计数
        if (progress === 100) {
          uploadedCount.value = fileIndex + 1
        }
        console.log(`文件 ${files.value[fileIndex].name} 上传进度: ${progress}%`)
      }
    )
    
    console.log('文件上传完成，URLs:', uploadedUrls)
    // 发送上传完成的事件
    emit('upload', uploadedUrls)
    
    // 清理状态
    files.value = null
    dialogVisible.value = false
    
  } catch (err: any) {
    console.error('上传过程发生错误:', err)
    error.value = err.message || '上传失败，请重试'
  } finally {
    uploading.value = false
    uploadProgress.value = 0
    uploadedCount.value = 0
    totalCount.value = 0
  }
}
</script>

<style scoped>
.upload-area {
  border: 2px dashed rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 20px 32px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #3A3B3F;
}

.upload-area:hover {
  border-color: var(--v-primary-base);
  background: rgba(var(--v-primary-base), 0.05);
}

.upload-area2 {
  border: 2px dashed rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  padding: 10px;
  text-align: center;
  cursor: pointer;
  transition: all 0.3s;
  background-color: #3A3B3F;
}

.upload-area2:hover {
  border-color: var(--v-primary-base);
  background: rgba(var(--v-primary-base), 0.05);
}

.hidden-input {
  display: none;
}

.file-list {
  border-radius: 8px;
  overflow: hidden;
  background-color: #3A3B3F !important;
}

.file-item {
  border-bottom: 1px solid rgba(255, 255, 255, 0.05);
  
  &:last-child {
    border-bottom: none;
  }
}

.progress-container {
  background: #3A3B3F;
  border-radius: 8px;
  padding: 16px;
}

.progress-info {
  flex: 1;
}

.waiting-files {
  font-size: 0.875rem;
  opacity: 0.7;
}

.paste-hint {
  background-color: #3A3B3F;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.875rem;
  border: 1px dashed rgba(255, 255, 255, 0.12);
}

.paste-shortcut {
  color: var(--v-primary-base);
  font-weight: 500;
}

kbd {
  background-color: #2B2D33;
  border: 1px solid rgba(255, 255, 255, 0.2);
  border-radius: 4px;
  padding: 2px 6px;
  font-family: monospace;
  font-size: 0.75rem;
  color: rgba(255, 255, 255, 0.8);
}

:deep(.v-card-text) {
  color: white !important;
}
.text-body-2{
  color:rgba(255, 255, 255, 0.26) !important
}
.v-list-item-title{
  color:rgba(255, 255, 255, 0.7) !important
}
.v-list-item-subtitle{
  color:rgba(255, 255, 255, 0.26) !important
}
</style>